import React, { useState } from 'react';
import { Link } from 'gatsby';

import axios from 'axios';
import Img from 'gatsby-image';

import { setDataLayer } from '../helpers/util';

export default ({ tags, currentUrl, dataLayerSource, sidebar }) => {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [sidebarValidationMsg, setSidebarValidationMsg] = useState('');


  /**
   * possible values of toDisplay:
   * - null
   * - validationError
   * - error
   * - success
   */
  const sendDataLayer = (actionType, inputType) => {
    const data = {
      event: 'formAction',
      formName: dataLayerSource,
      formActionType: actionType
    };

    if (inputType) {
      data.inputError = inputType;
    }

    setDataLayer(data);
  };

  const submitInitialDataLayer = () => {
    if (!isDirty) {
      sendDataLayer('start');
    }
    setIsDirty(true);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const data = {
      email,
      tags,
      signupSource: currentUrl,
      form: 'small'
    };
    try {
      setSending(true);
      await axios.post('/api/mcSubscribe', data).then(response => {
        setValidationMsg(response.data);
        setSidebarValidationMsg(sidebar && sidebar.form.successMessage || 'Something went wrong.');
      });
      setEmail('');
      sendDataLayer('submit_success');
    } catch (err) {
      setValidationMsg(err.response.data);
      setSidebarValidationMsg(sidebar && sidebar.form.errorMessage || 'Something went wrong.');
    } finally {
      setSending(false);
    }
  };

  const handleEmailChange = e => {
    setEmail(e.target.value);
  };
  return (
    <form
      name="ulam-presentation-form"
      onSubmit={handleSubmit}
      onChange={submitInitialDataLayer}
      className="w-100"
    >
      <div className="d-flex flex-column justify-content-center ">
        {validationMsg && !sidebar && (
          <div
            className={`mb-2 mb-0 h5 ${
              validationMsg === 'Subscribed!' ? 'succ-message' : 'err-message'
              } `}
          >
            {validationMsg}
          </div>
        )}
        {sidebar && (
          <div>
            <Img fluid={sidebar.image.childImageSharp.fluid} />
            <h3 className="title">{sidebar.title}</h3>
          </div>
        )}
        <input
          type="email"
          name="email"
          placeholder="Email"
          className="services-form-input rounded"
          onChange={handleEmailChange}
          value={email}
        />
        {sidebar && (
          <div className="mt-2 h5">
            <div
              className={`mb-2 mb-0 h5 ${
                sidebarValidationMsg === sidebar.form.successMessage ? 'succ-message text-dark' : 'err-message'
                } `}
            >
              {sidebarValidationMsg}
            </div>
          </div>
        )}
        <p className="services-form-text text-white my-3">
          {sidebar ? (
            sidebar.form.agreement
          ) : (
              <>
                Click &quot;Download&quot; to consent to processing your data by
                Ulam Labs for marketing purposes, including sending emails. For
              details see our{' '}
                <Link className="text-danger" to="/privacy-policy/">
                  Privacy Policy
              </Link>
                .
            </>
            )}
        </p>
        <button type="submit" className="btn btn-main fill mx-auto">
          {sending ? (
            <>
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
              <span className="sr-only">Loading...</span>
            </>
          ) : (
              'Download'
            )}
        </button>
      </div>
    </form>
  );
};
